import { DocumentTemplate } from '../../DocumentTemplate'
import { AnnotationsContainer } from '../../Annotations/AnnotationsContainer'
import type { FlattenedDocumentPage } from '@/lib/api/client'

interface ProjectsTrackerPageProps {
  pageTitle: string
  pageCreatedAt?: string
  pageId: string
  isReadOnly: boolean
  documentPage: FlattenedDocumentPage
}

export const ProjectsTrackerPage = ({
  pageId,
  pageTitle,
  pageCreatedAt,
  isReadOnly,
  documentPage,
}: ProjectsTrackerPageProps) => {
  return (
    <DocumentTemplate
      id={`${pageId}`}
      title={pageTitle}
      order={1}
      createdAt={pageCreatedAt}
    >
      <AnnotationsContainer
        documentPage={documentPage}
        isReadOnly={isReadOnly}
      />
    </DocumentTemplate>
  )
}
